import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4c6ecd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-font-text" }
const _hoisted_2 = { class: "add-experience" }
const _hoisted_3 = { class: "experiences" }
const _hoisted_4 = { key: 0 }

import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';
    import {useTranslation} from '@malt/vue3-use';
    import {computed, inject, onMounted, ref, toRef} from 'vue';
    import {useRouter} from 'vue-router';
    import {Experience} from '@/profile-creation-wizard/components/for-completion/domain/experience/Experience';
    import ExperienceComponent from '@/profile-creation-wizard/components/for-completion/ui/your-experience/components/Experience.vue';
    import StepItemTitle from '@/profile-creation-wizard/common/ui/StepItemTitle.vue';
    import ExperienceForm from '@/profile-creation-wizard/components/for-completion/ui/your-experience/components/ExperienceForm.vue';
    import YourExperienceSide from '@/profile-creation-wizard/components/for-completion/ui/your-experience/YourExperienceSide.vue';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';
    import DeleteExperienceDialog from '@/profile-creation-wizard/components/for-completion/ui/your-experience/components/DeleteExperienceDialog.vue';
    import actions from '@/profile-creation-wizard/store/completion/actions';
    import getters from '@/profile-creation-wizard/store/completion/getters';
    import {useStore} from 'vuex';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    const dataHeapTooltipID = 'profile-creation-tooltip-experience';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'YourExperienceStep',
  setup(__props) {

    const trackingRepository = inject(DI.trackingRepository);

    const router = useRouter();
    const {msg} = useTranslation();
    const store = useStore();
    const meta = computed(() => router.currentRoute.value.meta);

    const isLoading = ref<boolean>(false);
    const refExperiences = ref(null);
    const editingIndex = ref<number>(null);
    const isVisibleAddExperienceForm = ref(false);
    const isEditMode = ref(false);
    const isOpenDeleteExperienceDialog = ref<boolean>(false);
    const experienceToDelete = ref<Experience | null>(null);

    const activityAreas = computed(() => store.getters[getters.activityAreas]);

    const descriptionValidationRules = toRef(store.getters[getters.experienceDescriptionRule]);
    const experiences = computed(() => store.getters[getters.experiences]);

    const isStepOptional = computed(() => !store.state.isFunnelStrategy);
    const isNextStepEnabled = computed(() => isStepOptional.value || experiences.value.length > 0);

    let experienceToEdit: Experience | null = null;

    const bottomSheetDisplayer = ref<BottomSheetDisplayer>(null);
    onMounted(async () => {
        bottomSheetDisplayer.value = new BottomSheetDisplayer(
            '#completion-your-experience-bottom-sheet',
            dataHeapTooltipID,
            refExperiences.value,
            'div.profile-creation-wizard',
        );
    });

    function openAddExperienceForm() {
        if (isEditMode.value) {
            return;
        }
        experienceToEdit = null;
        isVisibleAddExperienceForm.value = true;
    }

    async function handleDeleteExperience() {
        try {
            closeDeleteExperienceDialog();
            const payload = experiences.value.filter((experience: Experience) => experience.id !== experienceToDelete.value.id);
            await updateExperiences(payload);
            editingIndex.value = null;
            experienceToDelete.value = null;
            isEditMode.value = false;
            pushNotification(msg('profile.creation.completion.wizard.v2.experience.deleteExperience.success'));
        } catch (e) {
            pushNotification(msg('profile.creation.common.notification.error.technical'), {level: 'error'});
        }
    }

    function setEditingIndex(index: number) {
        isEditMode.value = true;
        editingIndex.value = index === editingIndex.value ? null : index;
    }

    function handleExperienceFormCancel() {
        editingIndex.value = null;
        isVisibleAddExperienceForm.value = false;
        isEditMode.value = false;
    }

    async function handleAddExperience(experience: Experience) {
        try {
            await updateExperiences([...experiences.value, experience]);
            isVisibleAddExperienceForm.value = false;
            pushNotification(msg('profile.creation.completion.wizard.v2.experience.addNewExperience.success'));
        } catch (e) {
            pushNotification(msg('profile.creation.common.notification.error.technical'), {level: 'error'});
        }
    }

    async function handleEditExperience(editExperience: Experience) {
        try {
            const editedExperiences = [...experiences.value];
            editedExperiences[editingIndex.value] = editExperience;
            await updateExperiences(editedExperiences);
            editingIndex.value = null;
            isVisibleAddExperienceForm.value = false;
            isEditMode.value = false;
            pushNotification(msg('profile.creation.completion.wizard.v2.experience.editExperience.success'));
        } catch (e) {
            pushNotification(msg('profile.creation.common.notification.error.technical'), {level: 'error'});
        }
    }

    function openDeleteExperienceDialog(experience: Experience) {
        isOpenDeleteExperienceDialog.value = true;
        experienceToDelete.value = experience;
    }

    function closeDeleteExperienceDialog() {
        isOpenDeleteExperienceDialog.value = false;
    }

    async function updateExperiences(payload: Experience[]) {
        await store.dispatch(actions.updateExperiences, payload);
    }

    async function goNext() {
        await trackingRepository!.track(`work-experience-input-${meta.value.funnelMode}`, {experiences: experiences.value.length});
        router.push({name: router.currentRoute.value.meta.nextStep});
    }

    function openBottomSheet(): void {
        bottomSheetDisplayer.value.openBottomSheet();
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_divider_cta = _resolveComponent("joy-divider-cta")!
  const _component_VJoyScreenLoader = _resolveComponent("VJoyScreenLoader")!

  return (_openBlock(), _createBlock(Step, {
    "is-step-valid": isNextStepEnabled.value,
    "show-skip-step": isStepOptional.value,
    "is-skip-enabled": experiences.value.length === 0,
    onGoToNext: goNext
  }, {
    "step-content": _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "refExperiences",
        ref: refExperiences,
        class: "details-form__item"
      }, [
        _createVNode(StepItemTitle, { "is-optional": isStepOptional.value }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.experience.title')), 1)
          ]),
          _: 1
        }, 8, ["is-optional"]),
        _createElementVNode("p", _hoisted_1, [
          _createElementVNode("a", {
            class: "open-bottom-sheet",
            onClick: openBottomSheet
          }, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.experience.aboutWorkExperience')), 1)
        ])
      ], 512),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_joy_divider_cta, {
          disabled: isEditMode.value || isVisibleAddExperienceForm.value,
          onClick: openAddExperienceForm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.experience.cta.add')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        (isVisibleAddExperienceForm.value)
          ? (_openBlock(), _createBlock(ExperienceForm, {
              key: 0,
              "activity-areas": activityAreas.value,
              "description-validation-rules": descriptionValidationRules.value,
              "experience-to-edit": _unref(experienceToEdit),
              "onExperienceForm:add": handleAddExperience,
              "onExperienceForm:cancel": handleExperienceFormCancel
            }, null, 8, ["activity-areas", "description-validation-rules", "experience-to-edit"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_VJoyScreenLoader, null, {
                content: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.experience.loader.title')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(experiences.value, (experience, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `experience-${index}`
          }, [
            (editingIndex.value === index)
              ? (_openBlock(), _createBlock(ExperienceForm, {
                  key: 0,
                  "activity-areas": activityAreas.value,
                  "description-validation-rules": descriptionValidationRules.value,
                  "experience-to-edit": experience,
                  "onExperienceForm:cancel": handleExperienceFormCancel,
                  "onExperienceForm:add": handleAddExperience,
                  "onExperienceForm:edit": handleEditExperience
                }, null, 8, ["activity-areas", "description-validation-rules", "experience-to-edit"]))
              : (_openBlock(), _createBlock(ExperienceComponent, {
                  key: 1,
                  experience: experience,
                  "onExperience:delete": openDeleteExperienceDialog,
                  "onExperience:edit": ($event: any) => (setEditingIndex(index))
                }, null, 8, ["experience", "onExperience:edit"]))
          ], 64))
        }), 128))
      ]),
      _createVNode(DeleteExperienceDialog, {
        "is-opened": isOpenDeleteExperienceDialog.value,
        "onDeleteExperienceDialog:cancel": closeDeleteExperienceDialog,
        "onDeleteExperienceDialog:confirm": handleDeleteExperience
      }, null, 8, ["is-opened"])
    ]),
    "step-side": _withCtx(() => [
      _createVNode(YourExperienceSide)
    ]),
    _: 1
  }, 8, ["is-step-valid", "show-skip-step", "is-skip-enabled"]))
}
}

})